import { VMActions, VMScenes, VMTitleAndSceneInfo } from '../types/vm-types';
import { changeMetaInfoData } from '../utils/utils';
import { AppBridge } from './app-bridge';
import { logger_v2 as logger } from '@absis/shared';

const VM_APP_NAME = 'ventanamarco';

class VMBridge {
  private appBridge: AppBridge;

  constructor() {
    this.appBridge = new AppBridge();
  }

  public changeTitleAndScene(data: VMTitleAndSceneInfo): void {
    if (!this.isValidScene(data.scene)) {
      logger({
        message: `[BRIDGE-SERVICE] [VM-BRIDGE] ${
          data.scene
        } is not a valid type of scene. Valid types: ${this.getSceneValues().join(
          ', '
        )}`,
      });
    } else if (window.top) {
      const getEventFromJavaScript =
        (window.top.external as any).GetEventFromJavaScript ||
        (window.top.external as any).getEventFromJavaScript;
      if (getEventFromJavaScript) {
        const absis2Data = this.parseToAbsis2Data(
          VMActions.CHANGE_TITLE_AND_SCENE,
          data
        );
        getEventFromJavaScript(absis2Data);
      } else {
        // TODO: Publish PUB/SUB mechanism in future
        const absis2Data = this.parseToAbsis2Data(
          VMActions.CHANGE_TITLE_AND_SCENE,
          data
        );
        this.publish(VMActions.CHANGE_TITLE_AND_SCENE, absis2Data);
      }
    }
  }

  public subscribe(
    action: string,
    subscriber: (message?: string, data?: unknown) => unknown
  ): string {
    return this.appBridge.subscribe(VM_APP_NAME, action, subscriber);
  }

  public subscribeAll(
    subscriber: (message?: string, data?: unknown) => unknown
  ): string {
    return this.appBridge.subscribe(VM_APP_NAME, '', subscriber);
  }

  public unsubscribe(action?: string, token?: string): void {
    return this.appBridge.unsubscribe(VM_APP_NAME, action, token);
  }

  public getSubscriptions(): string[] {
    return this.appBridge.getSubscriptions(VM_APP_NAME);
  }

  public countSubscriptions(action?: string): number {
    return this.appBridge.countSubscriptions(VM_APP_NAME, action);
  }

  private publish(action: string, data: unknown): void {
    this.appBridge.publish(VM_APP_NAME, action, data);
  }

  private parseToAbsis2Data(action, data: VMTitleAndSceneInfo): unknown {
    let absis2Object: unknown = {};
    if (action === VMActions.CHANGE_TITLE_AND_SCENE) {
      absis2Object = changeMetaInfoData(data);
    }
    return `ABSIS2#${JSON.stringify(absis2Object)}`;
  }

  private isValidScene(scene: string | null | undefined) {
    return (
      scene === null ||
      scene === undefined ||
      Object.keys(VMScenes).some(function (key) {
        return VMScenes[key] === scene;
      })
    );
  }

  private getSceneValues() {
    const validSceneTypes: string[] = [];
    Object.keys(VMScenes).forEach(k => {
      validSceneTypes.push(VMScenes[k]);
    });
    return validSceneTypes;
  }
}

export { VMBridge };
